import { render, staticRenderFns } from "./resources-list-summary-item.vue?vue&type=template&id=41895556&"
import script from "./resources-list-summary-item.vue?vue&type=script&lang=js&"
export * from "./resources-list-summary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports